<script setup lang="ts">

  import type { ProductVariantResource } from '@storefront/resources';

  interface Props {
    variant: ProductVariantResource,
  }

  defineProps<Props>();
</script>
<template>
  <div class="product-actions">
    <SfWishlistButton :variant="variant.id" :variantModel="variant" v-slot="{ saved }">
      <SfButton small transparent>
        <template #before>
          <SfIconHeartFill v-if="saved" aria-hidden="true" />
          <SfIconHeart v-else aria-hidden="true" />
        </template>
        <template #default>
          {{ saved ? $t('SHOP.COMMON.LABEL.FAVORITE') : $t('SHOP.COMMON.ACTION.ADD_TO_WISHLIST') }}
        </template>
      </SfButton>
    </SfWishlistButton>
    <SfCompareButton :variant="variant.id" v-slot="{ compared }">
      <SfButton small transparent :danger="compared">
        <template #before>
          <SfIconScale aria-hidden="true" />
        </template>
        <template #default>
          {{ compared ? $t('SHOP.COMPARATOR.ACTION.REMOVE_FROM_COMPARISON') : $t('SHOP.COMPARATOR.ACTION.COMPARE') }}
        </template>
      </SfButton>
    </SfCompareButton>
  </div>
</template>
<style scoped lang="scss">
  .product-actions {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
</style>
